export default {
  enhance: 'AI_ENHANCEMENT_ENHANCE',
  acceptEnhancement: 'AI_ENHANCEMENT_ACCEPT',
  usage: 'AI_ENHANCEMENT_USAGE',
  settings: 'AI_ENHANCEMENT_SETTINGS',
  updateSettings: 'AI_ENHANCEMENT_SETTINGS_UPDATE',
  dismissEnhancement: 'AI_ENHANCEMENT_DISMISS',
};
